


const VideoBox = (): JSX.Element => {

	return (
		<div className='video-box'>

			<div className='video-wrapper'>
				<iframe
					src="https://www.youtube-nocookie.com/embed/1NT-tUg82uA"
					title="VETlímce video - Kočka"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
					allowFullScreen />
			</div>

			<h2>GASTRO límce je velkým pomocníkem a&nbsp;má řadu výhod:</h2>

			<ul>
				<li>usnadňuje proces čistění majiteli i&nbsp;kočce</li>
				<li>je&nbsp;komfortní a&nbsp;zajišťuje lepší fixaci</li>
				<li>nabízí řešení pro&nbsp;jednoduché přizpůsobení kanyly</li>
				<li>šetří čas i&nbsp;náklady</li>
				<li>snižuje související stres majitele i&nbsp;kočky</li>
				<li>odpovídá představám veterinárních lékařů</li>
				<li>je&nbsp;odolný proti&nbsp;kočičím drápkům a&nbsp;brání zadrápnutí</li>
			</ul>

		</div>
	);
};

export default VideoBox;